import React from "react";
import { useNavigate } from "react-router-dom";

const RestrictedAccess = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#fff1f6]">
      <div className="max-w-lg rounded-2xl bg-white p-10 text-center shadow-xl">
        <h1 className="mb-4 text-4xl font-bold text-red-600">
          Access Denied 🚫
        </h1>

        <p className="mb-6 text-lg text-gray-700">
          You do not have permission to access this page.
          <br /> Please contact the administrator if you believe this is an
          error.
        </p>

        <button
          onClick={() => navigate("/admin/dashboard")}
          className="rounded-xl bg-[#c51369] px-6 py-3 text-lg text-white transition-all hover:bg-[#f54ea2]"
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default RestrictedAccess;
